import { Vue, Component } from 'vue-property-decorator';
import {
    NOTIFICATION_TYPE_ERROR,
    NOTIFICATIONS,
    VrmNotification,
} from '@/vue/store/modules/notifications';

@Component
export default class WizardMixin extends Vue {
    created() {
        if (!this.$store.getters['MfaService/hasProtectedAccess']) {
            this.$router.replace('base.profile.twofactor');
            this.$store.dispatch(NOTIFICATIONS.ADD, {
                notification: new VrmNotification({
                    type: NOTIFICATION_TYPE_ERROR,
                    title: this.$t('mfa.unauthorized_title', { i18nFallback: 'Unauthorized' }),
                    message: this.$t('mfa.unauthorized_message', {
                        i18nFallback: 'You have not yet authorized for these protected settings.',
                    }),
                }),
            });
        }
    }
}
